import React from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import Home from './components/Home';
import Input from './components/Input';
import Page1 from './components/Page1';
import Page2 from './components/Page2';
import Page3 from './components/Page3';
import Page4 from './components/Page4';
import Page5 from './components/Page5';
import Page6 from './components/Page6';
import End from './components/End';

function App() {
  return (
    <HashRouter>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/"></Link>
            </li>
          </ul>
        </nav>


        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/input" element={<Input />} />
          <Route path='/page1' element={<Page1 />} />
          <Route path='/page2' element={<Page2 />} />
          <Route path='/page3' element={<Page3 />} />
          <Route path='/page4' element={<Page4 />} />
          <Route path='/page5' element={<Page5 />} />
          <Route path='/page6' element={<Page6 />} />
          <Route path='/end' element={<End />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
